export class CustomerSearchModel {
  sold_to_code: string;
  sold_to_name: string;
  ship_to_code: string;
  ship_to_name: string;
  sales_area: string;
}



// WEBPACK FOOTER //
// ./src/models/sap/customersearch.model.ts